<template>
  <li class="exhibitions_list_item">
    <template v-if="type === 'link'">
      <!-- objItem.link  -->
      <a v-if="objItem"  @click="go('vr_detail',objItem.id,objItem.code)" style="width: 100%;height: 100%" target="_blank">
        <div class="exhibitions_list_item_t">
          <div class="link">
            <img :src="objItem.coverPath" alt />
          </div>
        </div>
        <div class="exhibitions_list_item_b">
          <h3>
            <div class="link">
              {{objItem.name}}
            </div>
          </h3>
          <h4>{{common.filterHtml(objItem.synopsis)}}</h4>
          <div class="exhibitions_list_item_footer">
        <span>
          <i class="icon_school"></i>
          <div class="link">
            {{objItem.school_name}}
          </div>
        </span>
          </div>
        </div>
      </a>
    </template>
    <template v-else>
      <a v-if="objItem" class="link" @click="go('exhibitions_detail',objItem.id)">
      <div class="exhibitions_list_item_t">
        <div class="link">
          <img :src="objItem.coverPath" alt />
         </div> 
      </div>
      <div class="exhibitions_list_item_b">
        <h3>{{objItem.name}}</h3>
        <h4>{{objItem.synopsis}}</h4>
        <div class="exhibitions_list_item_footer">
        <span>
          <i class="icon_school"></i>
          <a  @click.stop="go('school_index',objItem.school)" class="link" v-if="objItem">
            {{objItem.school_name}}
          </a>
        </span>
          <span>
          <i class="icon_img"></i>{{objItem.opus_total || 0}}
        </span>
          <span>
          <i class="icon_eay"></i>{{objItem.popularity || 0}}
        </span>
        </div>
      </div>
      </a>
    </template>

  </li>
</template>

<script>
export default {
  props:{
    objItem: Object,
    type: {
      type: String,
      default: 'def'
    }
  },
  methods:{
    go(name,id,code){
      const { href } = this.$router.resolve({
        name: name,
        query: {
          id:id,
          code:code
        }
      });
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.exhibitions_list_item {
  cursor:pointer;
  width: 386px;
  margin: 0 20px 20px 0;
  box-sizing: border-box;
  .exhibitions_list_item_t {
    height: 231px;
    width: 100%;
    background: #f0f0f0;
    .link{
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
  .exhibitions_list_item_b {
    padding: 13px 20px 20px;
    box-sizing: border-box;
    background: #fff;
    h3 {
      font-size: 16px;
      line-height: 31px;
      color: #333;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      .link{
        font-size: 16px;
        color: #333;
      }
    }
    h4 {
      font-size: 14px;
      line-height: 22px;
      height: 61px;
      color: #999;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .exhibitions_list_item_footer {
      display: flex;
      align-items: center;
      margin-top: 19px;
      span {
        font-size: 12px;
        color: #999;
        display: flex;
        align-items: center;
        i {
          margin-right: 6px;
        }
        .link{
          font-size: 12px;
          color: #999;
        }
      }
      span + span {
        margin-left: 16px;
      }
    }
  }
}
</style>
